import { Skeleton } from '../ui/skeleton';

export function CourseSkeleton({ dashboard }) {
    if (dashboard) {
        return (
            <div className="flex flex-col md:flex-row gap-4 border border-neutral-300 rounded-2xl w-full max-w-3xl p-4 animate-pulse">
                {/* Image Section */}
                <Skeleton className="w-full md:w-50 h-40 md:h-auto rounded-lg shrink-0" />

                {/* Details Section */}
                <div className="flex-1 flex flex-col justify-between min-w-0">
                    {/* Title and Summary */}
                    <div className="shrink-0">
                        <Skeleton className="h-6 w-3/4 mb-2" />
                        <Skeleton className="h-4 w-full mb-1" />
                        <Skeleton className="h-4 w-5/6 mb-4" />
                    </div>

                    {/* Progress Bar */}
                    <div className="shrink-0 mb-4">
                        <div className="flex justify-between mb-2">
                            <Skeleton className="h-4 w-16" />
                            <Skeleton className="h-4 w-12" />
                        </div>
                        <Skeleton className="h-2 w-full rounded-full" />
                    </div>

                    {/* Action Buttons */}
                    <div className="shrink-0">
                        <div className="flex flex-col lg:flex-row gap-2">
                            <Skeleton className="h-10 w-full" />
                            <Skeleton className="h-10 w-full" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Non-dashboard (vertical card) skeleton
    return (
        <div className="flex flex-col border border-neutral-300 rounded-2xl p-4 animate-pulse">
            <Skeleton className="w-full h-40 mb-4 rounded-lg" />
            <div className="flex flex-col grow">
                <Skeleton className="h-6 w-3/4 mb-2" />
                <Skeleton className="h-4 w-full mb-1" />
                <Skeleton className="h-4 w-5/6 mb-4" />
                <Skeleton className="h-2 w-full rounded-full mb-4" />
                <Skeleton className="h-10 w-full" />
            </div>
        </div>
    );
}
